import { render, staticRenderFns } from "./magazine.vue?vue&type=template&id=a7883d0a&scoped=true"
import script from "./magazine.vue?vue&type=script&lang=js"
export * from "./magazine.vue?vue&type=script&lang=js"
import style0 from "./magazine.vue?vue&type=style&index=0&id=a7883d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7883d0a",
  null
  
)

export default component.exports